const APP_HOSTS: Record<string, string> = {
  "app.meetgail.com": "app.eu.meetgail.com",
  "app.staging-meetgail.com": "app.eu.staging-meetgail.com",
};

export type AppLinkRoutingOptions = {
  isFra1Region: boolean;
  gdprChecksEnabled: boolean;
};

function isAbsoluteAppUrl(href: string): boolean {
  return /^(https?:)?\/\//i.test(href);
}

export function routeGailAppUrl(
  href: string,
  { isFra1Region, gdprChecksEnabled }: AppLinkRoutingOptions,
): string {
  if (!isFra1Region || !gdprChecksEnabled || !isAbsoluteAppUrl(href)) {
    return href;
  }

  const isProtocolRelative = href.startsWith("//");

  try {
    const url = new URL(isProtocolRelative ? `https:${href}` : href);
    const euHost = APP_HOSTS[url.hostname];

    if (!euHost) return href;

    url.hostname = euHost;

    if (isProtocolRelative) {
      return `//${url.host}${url.pathname}${url.search}${url.hash}`;
    }

    return url.toString();
  } catch {
    return href;
  }
}
